import * as React from 'react'

export const PageContext = React.createContext([{} as any, (data: any) => {}])

export const PageProvider: React.FC<React.PropsWithChildren> = ({children}) => {
    const [pageOptions, setPageOptions] = React.useState({})

    return <PageContext.Provider value={[pageOptions, setPageOptions]}>{children}</PageContext.Provider>
}
